// cartActions.js

// Add to cart
export const addTocart = (data) => async (dispatch, getState) => {
  dispatch({
    type: "addToCart",
    payload: data,
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cart));
  return data;
};

// Remove from cart
export const removeFromCart = (data) => async (dispatch, getState) => {
  dispatch({
    type: "removeFromCart",
    payload: { _id: data._id, variantKey: data.variantKey },
  });
  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cart));
  return data;
};

// Clear cart
export const clearCart = () => async (dispatch) => {
  dispatch({
    type: "clearCart",
  });
  localStorage.setItem("cartItems", JSON.stringify([]));
};

